<template>
    <div>
        <div class="text-box main-text">
            <span class="main-icon"><font-awesome-icon icon="fa-solid fa-user" /></span>
            &nbsp;
            <span>{{obj.name}}</span>
        </div>

        <div class="text-box normal-text" v-show="showLocation !== false">
            <span><font-awesome-icon icon="fa-solid fa-location-dot" /></span>
            &nbsp;
            <span>{{countryName}}</span>
        </div>

        <div class="text-box normal-text">
            <span><font-awesome-icon icon="fa-solid fa-phone" /></span>
            &nbsp;
            <span>{{obj.telephone}}</span>
        </div>

        <div class="text-box normal-text">
            <span><font-awesome-icon icon="fa-solid fa-envelope" /></span>
            &nbsp;
            <span>{{obj.email}}</span>
        </div>
    </div>
</template>

<script setup>

//导入图标
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faUser, faLocationDot, faPhone, faEnvelope } from '@fortawesome/free-solid-svg-icons'
import {ref, onBeforeMount, toRef} from "vue"
import { getCountryObj } from "@/util/countrycode"
import {useUserinfo} from "@/stores/userinfo";
import myUtil from "@/util/util";

library.add(faUser, faLocationDot, faPhone, faEnvelope)

const props = defineProps(["obj", "showLocation"])

const countryName = ref("")
const userInfoRef = toRef(useUserinfo())

onBeforeMount(() => {
    if (props.showLocation !== false){

        if (myUtil.isNotEmpty(userInfoRef.value.country)){
            const countryObj = getCountryObj(userInfoRef.value.country)

            if (null != countryObj){
                if (userInfoRef.value.lang === "zh" || userInfoRef.value.lang === "szh"){
                    countryName.value = countryObj[userInfoRef.value.lang]
                }else{
                    countryName.value = countryObj.en
                }

            }

        }

    }

})

</script>

<style scoped>
.main-icon {
    color: #409EFF;
}

.main-text {
    font-size: 16px;
}

.normal-text {
    font-size: 16px;
}

.text-box {
    line-height: 1.5;
}

</style>